export default "__VITE_PUBLIC_ASSET__f3c1a580__"